import React, { useState } from 'react';
import { Mail } from 'lucide-react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  return <>
      <footer className="bg-charcoal text-white pt-10 pb-20 lg:pb-12 px-4 border-t border-white/10" data-id="element-63">
        <div className="max-w-5xl mx-auto" data-id="element-64">
          <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8 mb-8" data-id="element-65">
            {/* Brand */}
            <div data-id="element-66">
              <p className="font-serif text-xl text-gold font-bold mb-1" data-id="element-67">
                Plenava.com
              </p>
              <p className="text-sm text-gray-400 italic" data-id="element-68">
                Viajar a China Sin Estrés
              </p>
            </div>

            {/* Contact */}
            <div data-id="element-69">
              <p className="text-xs text-gray-500 uppercase tracking-wider mb-2 font-medium" data-id="element-70">
                Contacto
              </p>
              <a href="mailto:plenavaweb@gmail.com" className="inline-flex items-center text-sm text-gray-300 hover:text-gold transition-colors" data-id="element-71">
                <Mail className="h-4 w-4 mr-2 flex-shrink-0" data-id="element-72" />
                plenavaweb@gmail.com
              </a>
            </div>

            {/* Legal */}
            <div data-id="element-73">
              <p className="text-xs text-gray-500 uppercase tracking-wider mb-2 font-medium" data-id="element-74">
                Legal
              </p>
              <div className="flex flex-col gap-1.5" data-id="element-75">
                <button onClick={() => setPrivacyOpen(true)} className="text-sm text-gray-300 hover:text-gold transition-colors text-left" data-id="element-76">
                  Política de Privacidad
                </button>
                <button onClick={() => setTermsOpen(true)} className="text-sm text-gray-300 hover:text-gold transition-colors text-left" data-id="element-77">
                  Términos de Compra
                </button>
              </div>
            </div>
          </div>

          <div className="border-t border-white/10 pt-6 text-center" data-id="element-78">
            <p className="text-xs text-gray-500" data-id="element-79">
              © {new Date().getFullYear()} Plenava.com · Todos los derechos
              reservados.
            </p>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Política de Privacidad" data-id="element-80">
        <p data-id="element-81">
          <strong data-id="element-82">Responsable del tratamiento:</strong> Plenava.com
          (plenavaweb@gmail.com)
        </p>
        <p data-id="element-83">
          <strong data-id="element-84">Finalidad:</strong> Gestionar la compra y entrega del producto
          digital (ebook en formato PDF), así como atender consultas
          relacionadas.
        </p>
        <p data-id="element-85">
          <strong data-id="element-86">Base legal:</strong> Ejecución de un contrato (compra del
          ebook) y consentimiento del usuario para comunicaciones.
        </p>
        <p data-id="element-87">
          <strong data-id="element-88">Datos recopilados:</strong> Nombre, dirección de correo
          electrónico y datos de pago necesarios para procesar la transacción.
          Los datos de pago son gestionados directamente por la pasarela de pago
          correspondiente y no son almacenados por Plenava.com.
        </p>
        <p data-id="element-89">
          <strong data-id="element-90">Conservación:</strong> Los datos se conservarán mientras sean
          necesarios para cumplir con la finalidad para la que fueron recogidos
          y para cumplir con las obligaciones legales aplicables.
        </p>
        <p data-id="element-91">
          <strong data-id="element-92">Derechos:</strong> Puedes ejercer tus derechos de acceso,
          rectificación, supresión, oposición, limitación del tratamiento y
          portabilidad escribiendo a plenavaweb@gmail.com.
        </p>
        <p data-id="element-93">
          <strong data-id="element-94">Cesión a terceros:</strong> No se cederán datos a terceros
          salvo obligación legal o para la prestación del servicio (pasarela de
          pago, proveedor de email).
        </p>
        <p data-id="element-95">
          <strong data-id="element-96">Cookies:</strong> Este sitio web puede utilizar cookies
          técnicas y analíticas. Al navegar por el sitio, aceptas su uso
          conforme a esta política.
        </p>
        <p className="text-xs text-gray-400 mt-4" data-id="element-97">
          Última actualización: febrero 2026
        </p>
      </LegalModal>

      {/* Terms of Purchase Modal */}
      <LegalModal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Términos de Compra de Ebook" data-id="element-98">
        <p data-id="element-99">
          <strong data-id="element-100">1. Producto:</strong> "Viajar a China Sin Estrés (2026)" es un
          producto digital en formato PDF. Incluye el PDF principal, checklists
          imprimibles y plantillas según se describe en la página de venta.
        </p>
        <p data-id="element-101">
          <strong data-id="element-102">2. Entrega:</strong> Tras completar el pago, recibirás acceso
          inmediato al producto mediante descarga directa y/o enlace enviado a
          tu correo electrónico.
        </p>
        <p data-id="element-103">
          <strong data-id="element-104">3. Precio:</strong> El precio indicado en la página de venta
          (24€) incluye todos los impuestos aplicables. El pago se realiza en un
          único cobro, sin suscripciones ni cargos recurrentes.
        </p>
        <p data-id="element-105">
          <strong data-id="element-106">4. Derecho de desistimiento:</strong> Al tratarse de contenido
          digital suministrado de forma inmediata tras la compra, y de acuerdo
          con el artículo 103.m) del Real Decreto Legislativo 1/2007, el usuario
          acepta la pérdida del derecho de desistimiento una vez iniciada la
          descarga del producto.
        </p>
        <p data-id="element-107">
          <strong data-id="element-108">5. Licencia de uso:</strong> La compra otorga una licencia
          personal e intransferible. Queda prohibida la redistribución, reventa,
          copia o publicación total o parcial del contenido sin autorización
          expresa.
        </p>
        <p data-id="element-109">
          <strong data-id="element-110">6. Responsabilidad:</strong> La información contenida en el
          ebook es orientativa y se basa en la experiencia del autor.
          Plenava.com no se responsabiliza de cambios en normativas, apps o
          servicios de terceros posteriores a la fecha de publicación.
        </p>
        <p data-id="element-111">
          <strong data-id="element-112">7. Actualizaciones:</strong> Las posibles actualizaciones del
          producto se comunicarán por email. No existe obligación de
          proporcionar actualizaciones gratuitas.
        </p>
        <p data-id="element-113">
          <strong data-id="element-114">8. Contacto:</strong> Para cualquier consulta relacionada con
          tu compra, escríbenos a plenavaweb@gmail.com.
        </p>
        <p data-id="element-115">
          <strong data-id="element-116">9. Legislación aplicable:</strong> Estos términos se rigen por
          la legislación española. Para cualquier controversia, serán
          competentes los juzgados y tribunales del domicilio del consumidor.
        </p>
        <p className="text-xs text-gray-400 mt-4" data-id="element-117">
          Última actualización: febrero 2026
        </p>
      </LegalModal>
    </>;
}